module.exports = __webpack_public_path__ + "static/media/kevin.4eaed0bb.png";